import commonActions from '@/store/data/common/actions'
import { webRequestClient } from '@/services'
import { SOCIO_DEMO_CATEGORIES } from '@/utils/constants'
import { isEmpty, filter, concat, get } from 'lodash'
import { errorHandler } from '@/utils/helpers'
import helpers from './helpers'

const actions = {
    retrieveItems({ commit, rootState }) {
        //check if sociodemo data is active for this user, if not, don't fetch it
        const dataType = get(rootState.data.settings.sociodemo, 'demographic', null)
        if (!dataType) return

        commit('setIsLoading', true)
        const _route = helpers.buildRoutes(rootState.account)
        return webRequestClient
            .get(_route.route, _route.params)
            .then(demo => {
                if (get(demo, 'status') === 'KO') {
                    errorHandler('Error while retrieving demographic data', commit)
                } else if (!isEmpty(demo.list)) {
                    const countryCode2 = get(rootState, 'account.country.code2', '')
                    const displayDemo = filter(demo.list, dm => dm.is_visible === '1')
                    commit('setRetrievedItems', {
                        items: concat(SOCIO_DEMO_CATEGORIES, helpers.parseData(displayDemo, countryCode2))
                    })
                    commit('setCollection', helpers.instanciateAll(displayDemo, countryCode2))
                }
            })
            .catch(error => {
                errorHandler(error, commit)
            })
            .finally(() => {
                commit('setIsLoading', false)
            })
    }
}

export default { ...commonActions, ...actions }
